<template>
    <!-- <v-menu v-model="mostrar" :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>
            mdi-dots-vertical
          </v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="borrar" link>
          <v-list-item-icon>
            <v-icon>
              mdi-delete
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Eliminar
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu> -->
    <div>
      <v-tooltip
        v-if="mixValidaScopesActions(2)"
        top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="editar()">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip
        v-if="mixValidaScopesActions(3)"
        top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="borrar()">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Borrar</span>
        </v-tooltip>
    </div>
  </template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'OpcionesProyectoDocumentosTipos',
  props: {
    proyectoDocumentoTipo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrar: false,
    };
  },
  methods: {
    editar() {
      eventBus.$emit('editar-proyecto-documento-tipo', this.proyectoDocumentoTipo);
    },
    borrar() {
      eventBus.$emit('eliminar-proyecto-documento-tipo', this.proyectoDocumentoTipo);
    },
  },
};
</script>

  <style lang="scss"></style>
